import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import CrmKTP from "../../components/crmKTP";
import CrmTambahan from "../../components/crmTambahan";
import CrmMember from "../../components/crmMember";
import CrmSystem from "../../components/crmSystem";
import {mapToObjectDDL} from "../../../../common/mapper";
import Api from "../../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {
    loyaltyLevelOptions,
    memberLevelOptions,
    prospekCategoryOptions,
    prospekSourceOptions,
    prospekTypeOptions, specialCategoryOptions
} from "../../config/constants";
import * as R from "ramda";
import withFormGroup from "../../../../../modules/commons/withFormGroup";

class CRMAssignModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            options: {
                provinceOptions: [],
                kabkotOptions: [],
                kecamatanOptions: [],
                kelurahanOptions: [],
                zipCodeOptions: [],
                zipCodeRaw: [],
                genderOptions: [],
                religionOptions: [],
                hobbyOptions: [],
                interestOptions: [],
                prospekSourceCreateOptions: [],
                prospekCategoryOptions,
                prospekSourceOptions,
                prospekTypeOptions,
                memberLevelOptions,
                loyaltyLevelOptions,
                specialCategoryOptions,
            },
        }
    };

    componentDidMount() {
        if (!R.isNil(this.props.initialValues)) {
            console.log("here");
        }

        this.setDataOptions("prospekSourceCreateOptions", prospekSourceOptions.slice(1));

        this.fetchDataProvince();
        this.fetchBizpar();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.controls?.provinceId?.value?.value !== this.props.controls.provinceId?.value?.value) {
            this.setDataOptions("kabkotOptions", []);
            this.setDataOptions("kecamatanOptions", []);
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            this.props.setValue("kabKotId", "");
            this.props.setValue("kecamatanId", "");
            this.props.setValue("kelurahanId", "");
            this.props.setValue("zipcode", "");
            this.fetchDataKabKot(this.props.controls.provinceId?.value?.value);
        }
        if (prevProps.controls?.kabKotId?.value?.value !== this.props.controls.kabKotId?.value?.value) {
            this.setDataOptions("kecamatanOptions", []);
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            this.props.setValue("kecamatanId", "");
            this.props.setValue("kelurahanId", "");
            this.props.setValue("zipcode", "");
            this.fetchDataKecamatan(this.props.controls.kabKotId?.value?.value);
        }
        if (prevProps.controls?.kecamatanId?.value?.value !== this.props.controls.kecamatanId?.value?.value) {
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            this.props.setValue("kelurahanId", "");
            this.props.setValue("zipcode", "");
            this.fetchDataKelurahan(this.props.controls.kecamatanId?.value?.value);
        }
        if (prevProps.controls?.kelurahanId?.value?.value !== this.props.controls.kelurahanId?.value?.value && !R.isEmpty(this.state.options.zipCodeRaw)) {
            const data = this.state.options.zipCodeRaw.find(item => item.id === this.props.controls.kelurahanId?.value?.value);
            this.setDataOptions("zipCodeOptions", !R.isEmpty(data) ? [mapToObjectDDL(data.zipcode, data.zipcode)] : []);
        }
    };

    fetchDataProvince = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllProvince();
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("provinceOptions", response.data.data.map(item => mapToObjectDDL(item.provinceName, item.id)));

            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKabKot = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kabkotOptions", response.data.data.map(item => mapToObjectDDL(item.kabKotName, item.kabKotId)));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKecamatan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kecamatanOptions", response.data.data.map(item => mapToObjectDDL(item.kecamatanName, item.id)));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKelurahan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kelurahanOptions", response.data.data.map(item => mapToObjectDDL(item.kelurahanname, item.id)));
                this.setDataOptions("zipCodeRaw", response.data.data);
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchBizpar = async () => {
        const responses = await Promise.all([
            Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam({
                paramFilters: {bizparCategory: "GENDER_TYPE"},
            }),
            Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam({
                paramFilters: {bizparCategory: "RELIGION_TYPE"},
            }),
        ]);
        if (responses[0] && !R.isEmpty(responses[0].data.data)) {
            this.setDataOptions("genderOptions", responses[0].data.data.map(item => mapToObjectDDL(item.value, item.key)));
        }
        if (responses[1] && !R.isEmpty(responses[1].data.data)) {
            this.setDataOptions("religionOptions", responses[1].data.data.map(item => mapToObjectDDL(item.value, item.key)));
        }
    };

    setDataOptions = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            options: {
                ...prevValue.options,
                [name]: value,
            },
        }));
    };

    render() {
        return (
            <SimpleModal
                title={`Detail ${this.props.tab === "assigned" ? "Assign Prospek" : "Belum Assign"}`}
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <Tabs>
                            <TabList>
                                <Tab>Data KTP</Tab>
                                <Tab>Data Tambahan</Tab>
                                <Tab>Data Member</Tab>
                                <Tab>Data Sistem</Tab>
                            </TabList>
                            <TabPanel>
                                <CrmKTP
                                    {...this.props}
                                    options={this.state.options}
                                />
                            </TabPanel>
                            <TabPanel>
                                <CrmTambahan
                                    {...this.props}
                                    options={this.state.options}
                                />
                            </TabPanel>
                            <TabPanel>
                                <CrmMember
                                    {...this.props}
                                    options={this.state.options}
                                />
                            </TabPanel>
                            <TabPanel>
                                <CrmSystem
                                    {...this.props}
                                    options={this.state.options}
                                />
                            </TabPanel>
                        </Tabs>
                        {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                    </ModalContainer>
                }
            />
        )
    }
}

export default withFormGroup(CRMAssignModifying);